import React, { FC, ReactElement, useState } from 'react'
import * as yup from 'yup'
import { Formik } from 'formik'
import { Form, Alert } from 'react-bootstrap'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import Auth from '@aws-amplify/auth'
import LoadingButton from '../LoadingButton'

interface Props extends RouteComponentProps {
  email: string
  password: string
  setIsAuthenticated: (isAuthenticated: boolean) => void
  setEmail: (email: string) => void
  setPassword: (password: string) => void
}

const schema = yup.object({
  confirmationCode: yup.string().required('Confirmation code is required'),
})

const ConfirmForm: FC<Props> = ({
  email,
  password,
  setEmail,
  setPassword,
  setIsAuthenticated,
  history,
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  const confirm = async (values: { confirmationCode: string }): Promise<void> => {
    setIsLoading(true)

    try {
      await Auth.confirmSignUp(email, values.confirmationCode)
    } catch (e) {
      setErrorMessage(e.message)
      setIsLoading(false)
    }

    try {
      await Auth.signIn(email.toLocaleLowerCase(), password)

      // TODO: not very secure, should probably figure out
      // a way to not be storing credentials in state
      setEmail('')
      setPassword('')

      setIsAuthenticated(true)
      setErrorMessage('')
      setIsLoading(false)

      history.push('/')
    } catch (e) {
      setErrorMessage(e.message)
      setIsLoading(false)
    }
  }

  return (
    <>
      {errorMessage && (
        <Alert variant="danger">
          <Alert.Heading>Error</Alert.Heading>
          <span>{errorMessage}</span>
        </Alert>
      )}
      <Formik
        validationSchema={schema}
        onSubmit={confirm}
        initialValues={{
          confirmationCode: '',
        }}
      >
        {({ handleSubmit, values, handleChange, touched, errors, submitCount }): ReactElement => (
          <Form noValidate onSubmit={handleSubmit}>
            <Form.Group controlId="confirmationCode">
              <Form.Label>Confirmation Code</Form.Label>
              <Form.Control
                type="text"
                required
                value={values.confirmationCode}
                onChange={handleChange}
                isValid={touched.confirmationCode && !errors.confirmationCode}
                isInvalid={submitCount > 0 && !!errors.confirmationCode}
              />
              <Form.Control.Feedback type="invalid">
                <Alert variant="danger">{errors.confirmationCode}</Alert>
              </Form.Control.Feedback>
              <h6>{`Please check your email (${email}) for your confirmation code.`}</h6>
            </Form.Group>
            <Form.Group controlId="actions" className="actions">
              <LoadingButton
                className="signup-button"
                variant="primary"
                block
                type="submit"
                isLoading={isLoading}
              >
                SUBMIT
              </LoadingButton>
            </Form.Group>
          </Form>
        )}
      </Formik>
    </>
  )
}

export default withRouter(ConfirmForm)
